import { MenuLinkTypeEnum } from 'common/components/entities/Menu/enums/MenuLinkTypeEnum'
import { BaseMenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { isBlogReplacementPlaceholder } from 'common/utils/blogReplacementsUtils'
import { isWebsitePageUrlPlaceholder } from 'common/utils/website-replacements-utils'

export const detectLinkType = (
  item: BaseMenuItemInterface,
  isAllowedBlogLinks: boolean,
  isAllowedWebsiteLinks: boolean,
) => {
  if (isAllowedBlogLinks) {
    if (
      isBlogReplacementPlaceholder(item.link.replace(/\d+/g, ' ')) ||
      item.link === ''
    ) {
      return MenuLinkTypeEnum.link_type_blog_page
    }
  } else if (isAllowedWebsiteLinks) {
    if (
      isWebsitePageUrlPlaceholder(item.link.replace(/\d+/g, ' ')) ||
      item.link === ''
    ) {
      return MenuLinkTypeEnum.link_type_website_page
    }
  }

  return MenuLinkTypeEnum.link_type_custom_url
}
